export default import.meta.ROLLDOWN_FILE_URL_kbG$f3FFPYGya0JEuXDYYw